const marcos = [
  {name: 'Sin Marco (enrollado)', url: 'https://cdn.shopify.com/s/files/1/0642/8580/2704/files/frame-dorado.png'},
  {name: 'Marco Blanco', url: 'https://cdn.shopify.com/s/files/1/0642/8580/2704/files/frame-plateado.png'},
  {name: 'Marco Negro', url: 'https://cdn.shopify.com/s/files/1/0642/8580/2704/files/frame-negro.png'},
  {name: 'Marco Madera', url: 'https://cdn.shopify.com/s/files/1/0642/8580/2704/files/frame-verde2.png'},
  {name: 'Madera Verde', url: 'https://cdn.shopify.com/s/files/1/0642/8580/2704/files/frame-verde1.png'},
  {name: 'Madera Plateado', url: 'https://cdn.shopify.com/s/files/1/0642/8580/2704/files/frame-verde1.png'},
  {name: 'Madera Madera Oscura', url: 'https://cdn.shopify.com/s/files/1/0642/8580/2704/files/frame-dorado.png'}
];

const plexiglassControl = document.querySelector('#SingleOptionSelector-2');
const radios = document.querySelectorAll('input[name="MARCO"]');
const selectedMarco = document.querySelector('input[name="MARCO"]:checked')?.value;

if(selectedMarco != 'Sin Marco (enrollado)') {
  if(plexiglassControl) {
    plexiglassControl.classList.remove('hidden');
  }
}

radios.forEach(radio => {
  radio.addEventListener('change', event => {
    if(plexiglassControl) {
        if (event.target.checked && event.target.value != 'Sin Marco (enrollado)') {
            plexiglassControl.classList.remove('hidden');
        } else {
            plexiglassControl.classList.add('hidden');
        }
    }
  });
});

(function () {
  let currentUrl = window.location.href;

  const checkVariantInUrl = () => {
    
    const internalSelectedMarco = document.querySelector('input[name="MARCO"]:checked')?.value;
    const internalMarco = marcos.find( marco => marco.name == internalSelectedMarco );
    if(internalMarco) {
      const marcoElementImg = document.querySelector('#frame-overlay');

      if(marcoElementImg) {
        marcoElementImg.setAttribute('src', internalMarco.url);
      }
    }


  };

  // Verifica al cargar
  checkVariantInUrl();

  // Observa cambios en el DOM que podrían acompañar cambios de URL
  const observer = new MutationObserver(() => {
    if (window.location.href !== currentUrl) {
      currentUrl = window.location.href;
      checkVariantInUrl();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();


function getProductHandleFromUrl() {
  const path = window.location.pathname;
  const segments = path.split('/');
  const handle = segments.includes('products') ? segments.pop() : null;
  return handle;
}

function formatMoney(cents, format = "$ {{amount}}") {
  if (typeof cents !== "number") cents = parseInt(cents, 10);
  let amount = cents / 100;

  if (format.includes("amount_no_decimals")) {
    amount = Math.round(amount).toString();
  } else {
    amount = amount.toFixed(2);
  }

  if (format.includes("comma_separator")) {
    amount = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  return format.replace(/{{\s*amount.*?}}/, amount);
}